import { DesignTokens } from '@givelify/ui';
import { styled } from '@mui/material';

export const MessengerTextBox = styled('div')(({ theme }) => ({
    display: 'flex',
    marginTop: theme.spacing(1),
    '& .text-area': {
        marginLeft: theme.spacing(2),
        minWidth: '50%',
        maxWidth: 700,
    },
    '& .text-field': {
        maxWidth: '100%',
        width: '100%',
        '& .MuiInputBase-root': {
            backgroundColor: theme.palette.background.paper,
            minHeight: '32px',
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            borderRadius: theme.spacing(3),
        },
        '& .MuiInputBase-input': {
            backgroundColor: theme.palette.background.paper,
            border: 'none',
            boxShadow: 'none',
            paddingTop: 10,
            paddingBottom: 10,
            fontSize: 16,
            color: DesignTokens.color.navigationTextDefault,
            paddingRight: 24,
        },
        '& .Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: 2,
                borderStyle: 'solid',
                borderColor: DesignTokens.color.borderComponentFocused,
            },
        },
    },
    '& .error': {
        fontSize: 12,
        color: theme.palette.error.main,
    },
    '& .instruction': {
        fontSize: 12,
        color: '#ccc',
    },
    '& .avatar': {
        marginTop: 5,
    },
}));

export const MessengerHint = styled('div')(() => ({
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 600,
    color: DesignTokens.color.textSecondary,
    marginTop: 4,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '& .primary': {
        color: DesignTokens.color.primaryDarkGray,
    },
}));
